import React, { useState } from "react";
import ForgetPasswordDialog from "./ForgetPasswordDialog";

const ForgetPassword = () => {
  const [open, setOpen] = useState(true);

  return (
    <div>
      {open && <ForgetPasswordDialog open={open} onClose={() => setOpen(false)} />}
    </div>
  );
};

export default ForgetPassword;
